import { api } from '../utils'

export const uploadFile = file =>
  api.upload('/media', file).then(resp => resp?.data)

export const openMedia = filename => api.get(`/media/${filename}/url`)
export const downloadMedia = filename => api.get(`/media/${filename}/download`)
